import { render, staticRenderFns } from "./pointAdd.vue?vue&type=template&id=e7bb99c6&scoped=true&"
import script from "./pointAdd.js?vue&type=script&lang=js&"
export * from "./pointAdd.js?vue&type=script&lang=js&"
import style1 from "./pointAdd.vue?vue&type=style&index=1&id=e7bb99c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7bb99c6",
  null
  
)

export default component.exports